import Landing from '../components/Landing'

export default {
  path: '/',
  component: Landing,
  meta: {
    title: 'Photographers101',
    login: false,
    loginType: 'all'
  }
}
